import React, { useEffect, useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

import { useGetUserInfo } from '../../hooks/useGetUserInfo'

export default function ConstructionsForm({
  onSubmit,
  handleCancel,
  construction,
  previousRoute,
}) {
  const editing = construction && construction.id
  const user = useGetUserInfo()
  const building = user?.building
  const classes = useStyles()
  const history = useHistory()

  const parseFromApi = (data) => {
    if (!data) return null
    return {
      ...data,
      apartments: data.apartments,
    }
  }

  const [values, setValues] = useState(parseFromApi(construction) || {})
  const [selectedBuilding, setSelectedBuilding] = useState(building)
  const [apartments, setApartments] = useState(construction?.apartments || [])

  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()

  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()

  useEffect(() => {
    const fetchBuildingData = async () => {
      getBuildings()
    }
    fetchBuildingData()
  }, [])

  useEffect(() => {
    if (selectedBuilding) {
      const fetchApartmentsFromBuilding = async () => {
        getApartmentsFromBuilding(selectedBuilding.id)
      }
      fetchApartmentsFromBuilding()
    }
  }, [selectedBuilding])

  useEffect(() => {
    if (user?.building) {
      setSelectedBuilding(user.building)
    }
  }, [user])

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={editing ? 'Editar obra' : 'Nueva obra'}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            onlyLetters: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Descripción',
            hint: 'Ingrese una descripción',
            key: 'description',
            errorMessage: 'La descripción es requerida',
            withMargin: true,
          },
          {
            type: FieldTypes.DatePicker,
            label: 'Fecha de inicio',
            hint: 'Ingrese una fecha de inicio',
            key: 'date',
            errorMessage: 'La fecha de inicio es requerida',
            withMargin: true,
          },
          ...(!building
            ? [
                {
                  type: FieldTypes.DoubleAutocomplete,
                  autocompletes: [
                    {
                      label: 'Cliente',
                      hint: 'Seleccione un cliente',
                      key: 'building',
                      options: buildingsState.buildings,
                      multiple: false,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setSelectedBuilding(value)
                      },
                    },
                    {
                      label: 'Unidad',
                      hint: 'Seleccione un apartamento',
                      key: 'apartment',
                      options: getApartmentsFromBuildingState.apartments,
                      multiple: true,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setApartments(value)
                      },
                    },
                  ],
                },
              ]
            : []),
          ...(building
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Unidad',
                  hint: 'Seleccione un apartamento',
                  key: 'apartments',
                  options: getApartmentsFromBuildingState.apartments,
                  multiple: true,
                  freeSolo: false,
                  withMargin: true,
                  disabled: values.global,
                  onChange: (value) => {
                    setApartments(value)
                  },
                  value: apartments,
                },
              ]
            : []),
        ]}
        handleSubmit={() => {
          onSubmit(
            {
              ...values,
              ...(selectedBuilding && { buildingId: selectedBuilding.id }),
              ...(apartments && { apartments: apartments.map((a) => a.id) }),
            },
            () => history.push(previousRoute || '/obras')
          )
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
